export const logEvent = event => {
  try {
    window.appboy.logCustomEvent(event);
  } catch (error) {
    console.error(error);
  }
};
export default { logEvent };
